import { BoatApiService } from './boat-api-service';
import { IDataProviderService } from './data-provider';

export class TrailerApiService extends BoatApiService implements IDataProviderService {

  static serviceName = 'trailerApiService';

  
  constructor() {
    super('1');
  }
}


TrailerApiService.define();